module.exports = __webpack_public_path__ + "img/icon-indi-96-waterdrop.92a34597.svg";